<template>
  <div class="adsorption-container">
    <!-- 上部分 -->
    <div class="adsor-top-section">
      <div class="adsor-image-container" ref="ad-image1">
        <img src="../../static/series/AdsorptionForce/图片2.png" class="adsor-top-image"/>
        <div class="text-overlay">
          <div class="text-line-1">Mars 55</div>
          <div class="text-line-2">-6.7 inhg</div>
        </div>
      </div>
      <div class="adsor-image-container" ref="ad-image2">
        <img src="../../static/series/AdsorptionForce/图片3.png" class="adsor-top-image"/>
        <div class="text-overlay">
          <div class="text-line-1">Mars 50</div>
          <div class="text-line-2">-6.0 inhg</div>
        </div>
      </div>
    </div>

    <!-- 中间部分 -->
    <div class="adsor-middle-section">
      <p>{{ $t('series.vacuum') }}<br/>{{ $t('series.match_vacuum') }}</p>
    </div>
    <div class="saturn-force">
      <span class="saturn-force-text">One more thing…</span>
    </div>

    <!-- 下部分 -->
    <div class="ad-bottom-section">
      <div class="card" v-for="(card, index) in cards" :key="index" :ref="`ad_card_${index}`">
        <div class="plus-sign">+</div>
        <div class="card-text">
          <div class="first-line">
            IEC <span class="power-text">{{ card.power }}</span> IE{{ card.ie }}
            <span class="bold-text">{{ card.boldText }}</span>
          </div>
          <div class="second-line">{{ card.secondPart }}</div>
        </div>
        <img :src="card.imageUrl" alt="Card Image" class="card-image"/>
      </div>
    </div>


  </div>
</template>

<script>
import image1 from "../../static/series/AdsorptionForce/force1.png"
import image2 from "../../static/series/AdsorptionForce/force2.png"
import image4 from "../../static/series/AdsorptionForce/force3.png"
import image3 from "../../static/series/AdsorptionForce/force4.png"

export default {
  name: "AdsorptionForce",
  data() {
    return {
      cards: [
        {
          power: "22kw",
          ie: "4",
          boldText: this.$i18n.t('series.motor'),
          secondPart: "22kw VFD",
          imageUrl: image1
        },
        {
          power: "30kw",
          ie: "4",
          boldText: this.$i18n.t('series.motor'),
          secondPart: "30kw VFD",
          imageUrl: image2
        },
        {
          power: "37kw",
          ie: "5",
          boldText: this.$i18n.t('series.motor'),
          secondPart: "37kw VFD",
          imageUrl: image3
        },
        {
          power: "45kw",
          ie: "5",
          boldText: this.$i18n.t('series.motor'),
          secondPart: "45kw VFD",
          imageUrl: image4
        },
      ],
      isMobile: false
    };
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);

    this.$nextTick(() => {
      const isMobile = this.isMobile;
      // 移动端动画参数调整
      const animationParams = {
        mobile: {
          startTrigger: 'top 90%',  // 更靠下的触发点
          endTrigger: 'bottom 70%',
          initialY: 30,             // 初始位移减小
          duration: 1.2,            // 动画时长
          stagger: 0.3              // 元素间隔时间
        },
        pc: {
          startTrigger: 'top 75%',
          endTrigger: 'bottom 60%',
          initialY: 50,
          duration: 1.5,
          stagger: 0.2
        }
      };

      const params = isMobile ? animationParams.mobile : animationParams.pc;

      let elementRefs = [
        this.$refs['ad-image1'],
        this.$refs['ad-image2'],
        '.adsor-middle-section',
        this.$refs['ad_card_0'],
        this.$refs['ad_card_1'],
        this.$refs['ad_card_2'],
        this.$refs['ad_card_3'],
      ];

      // 设置初始状态
      this.$gsap.set(elementRefs, {
        opacity: 0,
        y: params.initialY
      });

      this.$gsap.set('.saturn-force', {
        opacity: 0
      })

      // 创建时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.adsorption-container',  // 使用容器作为触发点更稳定
          start: params.startTrigger,
          end: params.endTrigger,
          toggleActions: 'play none none none',
          markers: false,
          once: true
        }
      });

      // 按顺序显示元素，移动端延长间隔时间
      elementRefs.forEach((item, index) => {
        masterTimeline.to(item, {
          opacity: 1,
          y: 0,
          duration: params.duration,
          ease: 'power2.out'
        }, params.stagger * index);
      });

      //  ad-bottom-section
      masterTimeline.to('.ad-bottom-section ', {
        opacity: 0,
        duration: 1.5,
      }, 3)

      // 修改背景颜色  adsorption-container
      masterTimeline.to('.adsorption-container', {
        '--color-start': '#d7d8d8',
        '--color-end': '#273953',
        duration: 1.5,
      }, 3)

      // adsor-top-section  adsor-middle-section
      masterTimeline.to(['.adsor-top-section', '.adsor-middle-section'], {
        y: -70,
        duration: 1.5,
      }, 3)

      //adsor-middle-section
      masterTimeline.to('.adsor-middle-section', {
        color: '#808080',
        duration: 1.5,
      }, 3)

      //  one more thing    saturn-force

      masterTimeline.to('.saturn-force', {
        opacity: 1,
        y: -50,
        duration: 1.5,
      }, 4)
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  }
};
</script>

<style scoped>
.adsorption-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  min-height: 1000px; /* 改为min-height避免内容溢出 */
  margin: 0 auto;
  margin-top: 300px;
  box-sizing: border-box;

  /* 用 CSS 变量定义渐变的两个颜色 */
  --color-start: #d7d8d8; /* 起始色（红色） */
  --color-end: #d7d8d8; /* 结束色（蓝色） */
  /* 使用变量构建渐变 */
  background-image: linear-gradient(var(--color-start), var(--color-end));
}

/* 上部分样式 */
.adsor-top-section {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  align-items: center;
  height: 200px;
}

.adsor-image-container {
  position: relative;
  margin: 0 10px;
}

.adsor-top-image {
  width: 70%;
  height: auto;
}

.text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
}

.text-line-1 {
  color: black;
  font-size: var(--font-size-xl);
  font-weight: bold;
}

.text-line-2 {
  font-size: var(--font-size-xl);
}

/* 中间部分样式 */
.adsor-middle-section {
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  white-space: pre-line
}

.adsor-middle-section p {
  text-align: center;
  font-size: 2.5em;
}

/* 下部分样式 */
.ad-bottom-section {
  display: flex;
  justify-content: center;
  width: 95%;
  margin-top: 30px;
}

.card {
  display: flex;
  height: 500px;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  margin: 0 5px;
  width: 23%;
  gap: 50px;
}

.plus-sign {
  font-size: 2.5em;
  margin-bottom: 5px;
  align-self: flex-start;
}

.card-text {
  font-size: 1.5em;
  text-align: left;
  color: #808080;
}

.first-line {
  margin-bottom: 5px;
  line-height: 1.5;
}

/* 功率数值(22kw等)设置为黑色 */
.power-text {
  color: black;
}

.second-line {
  line-height: 1.5;
}

.card-image {
  width: 70%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.saturn-force-text {
  color: #ffffff;
  font-size: var(--font-size-xl);
}

/* 手机端适配 - 屏幕宽度小于768px时 */
@media (max-width: 768px) {
  .adsorption-container {
    padding: 15px;
    margin-top: 100px; /* 减少顶部距离 */
    min-height: auto; /* 自适应高度 */
    padding-bottom: 50px; /* 增加底部 padding */
  }

  /* 上部分样式调整 */
  .adsor-top-section {
    height: auto;
    flex-direction: column;
    gap: 30px; /* 增加间距 */
    margin-bottom: 30px;
    margin-top: 20px;
  }

  .adsor-image-container {
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .adsor-top-image {
    width: 60%; /* 调整图片大小 */
  }

  .text-line-1 {
    font-size: 1.5em;
  }

  .text-line-2 {
    font-size: 1.2em;
  }

  /* 中间部分样式调整 */
  .adsor-middle-section {
    margin: 30px 0;
  }

  .adsor-middle-section p {
    font-size: 1.5em; /* 减小字体 */
    text-align: center;
    line-height: 1.5;
  }

  /* 下部分样式调整 - 改为垂直排列 */
  .ad-bottom-section {
    flex-direction: column;
    gap: 20px;
    width: 100%;
    margin-top: 10px;
  }

  .card {
    width: 90%;
    height: auto;
    min-height: 250px; /* 调整卡片最小高度 */
    margin: 0;
    gap: 15px; /* 减小内部间距 */
    padding: 15px;
  }

  /* 卡片内部元素调整 */
  .plus-sign {
    font-size: 1.5em;
    margin-bottom: 10px;
  }

  .card-text {
    font-size: 1em; /* 调整文字大小 */
  }

  .card-image {
    width: 50%; /* 调整图片大小 */
    margin-top: 10px;
  }
}

/* 平板适配 - 屏幕宽度在768px到1024px之间时 */
@media (min-width: 769px) and (max-width: 1024px) {
  .ad-bottom-section {
    flex-wrap: wrap;
    gap: 20px;
  }

  .card {
    width: calc(50% - 20px);
    margin: 0;
    height: 400px;
  }
}
</style>
